<template>
  <div class="page_wrapper">
    <!-- 顶部导航栏 -->
    <div class="back_box">
      <div class="back_left">
        <div class="back_btn" @click="backPage">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <div class="page_title">
          <span class="class_name">{{ className }}</span>
          <span class="title_sep">/</span>
          统一考试
        </div>
      </div>
    </div>

    <div class="start_box">
      <!-- 左侧：考试信息 + 学员信息 -->
      <div class="left">
        <div class="section_card">
          <div class="section_title">
            <span class="title_icon exam_icon"></span>
            考试信息
          </div>
          <div class="info_list">
            <div class="info_item title_row">
              <span class="info_label">考试名称</span>
              <span class="info_value title_value">{{ pageData.grant_info.title }}</span>
            </div>
            <div class="info_item">
              <span class="info_label">考试时间</span>
              <span class="info_value">{{ pageData.grant_info.start_time.format }}</span>
            </div>
            <div class="info_item">
              <span class="info_label">禁止进入时间</span>
              <span class="info_value">{{ pageData.grant_info.end_time.format }}</span>
            </div>
            <div class="info_item">
              <span class="info_label">考试时长</span>
              <span class="info_value highlight">{{ pageData.grant_info.exam_duration }} 分钟</span>
            </div>
            <div class="info_item">
              <span class="info_label">合格分数</span>
              <span class="info_value highlight">{{ pageData.grant_info.qualified_score }} 分</span>
            </div>
            <div class="info_item">
              <span class="info_label">允许进入次数</span>
              <span class="info_value">{{ pageData.recordNum }} / {{ pageData.grant_info.allow_num }}</span>
            </div>
          </div>
        </div>

        <div class="section_card">
          <div class="section_title">
            <span class="title_icon user_icon"></span>
            学员信息
          </div>
          <div class="info_list">
            <div class="info_item">
              <span class="info_label">单位</span>
              <span class="info_value">{{ pageData.stu_info.work_unit }}</span>
            </div>
            <div class="info_item name_row">
              <span class="info_label">考生姓名</span>
              <span class="info_value">{{ pageData.stu_info.stu_name }}</span>
            </div>
            <div class="info_item">
              <span class="info_label">考生性别</span>
              <span class="info_value">{{ pageData.stu_info.stu_sex.name }}</span>
            </div>
            <div class="info_item phone_row">
              <span class="info_label">手机号码</span>
              <span class="info_value mono_value">{{ pageData.stu_info.stu_tel.val }}</span>
            </div>
            <div class="info_item id_row">
              <span class="info_label">身份证号码</span>
              <span class="info_value mono_value">{{ pageData.stu_info.stu_code.val }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 左右分栏装饰线 -->
      <div class="divider_line"></div>

      <!-- 右侧：考生须知 + 操作按钮 -->
      <div class="right">
        <div class="section_card notice_card">
          <div class="section_title center_title">
            <span class="title_icon notice_icon"></span>
            考生须知
          </div>
          <div class="info_box">
            <div class="notice_item">
              <span class="notice_num">1</span>
              <span class="notice_text">考试系统只能通过鼠标操作</span>
            </div>
            <div class="notice_item">
              <span class="notice_num">2</span>
              <span class="notice_text">通过点击鼠标选中相应的答案，选中后点击下一题继续答题</span>
            </div>
            <div class="notice_item">
              <span class="notice_num">3</span>
              <span class="notice_text">点击"上一题"、"下一题"或者答题卡的某一题进行题目的切换；点击"提交试卷"将提交试卷，交卷后不能再进行修改，并立即给出考试成绩</span>
            </div>
            <div class="notice_item">
              <span class="notice_num">4</span>
              <span class="notice_text">请安装谷歌浏览器或者最新360极速浏览器进行考试</span>
            </div>
            <div class="notice_item">
              <span class="notice_num">5</span>
              <span class="notice_text">考试时间到才能进入进行答题，请耐心等待</span>
            </div>
            <div class="notice_item">
              <span class="notice_num">6</span>
              <span class="notice_text">考试前请关闭电脑其他软件，避免因为意外造成考试退出，一旦退出则视为交卷</span>
            </div>
            <div class="notice_item">
              <span class="notice_num">7</span>
              <span class="notice_text">考试时间到，若考生仍未提交试卷，系统将自动提交</span>
            </div>
            <div class="notice_item notice_warn">
              <span class="notice_num warn_num">8</span>
              <span class="notice_text warn_text"><b>【重要提醒】</b>考试过程中不能切换屏幕、退出全屏，系统检测到切屏或退出全屏将自动交卷，无法再进行作答</span>
            </div>
          </div>
        </div>

        <div class="btn_area" :class="{ area_ready: btnIsCanClick }">
          <div class="countdown_box" :class="{ countdown_ready: btnIsCanClick }">
            <span class="countdown_dot"></span>
            <span class="countdown_label">{{ overTimeText }}</span>
            <span class="countdown_icon" :class="{ icon_ready: btnIsCanClick }"></span>
          </div>
          <div class="btn_group">
            <!-- <div class="btn btn_secondary" :class="[btnIsCanClick == false ? 'btn_disable' : '']" v-if="pageData.recordNum > 0"
              @click="examAgin()">
              申请重考
            </div> -->
            <div class="btn btn_primary" :class="[btnIsCanClick == false ? 'btn_disable' : '']" @click="jumpExam()" v-throttle>
              确认无误，进入考试
            </div>
          </div>
          <div class="btn_hint">请仔细核对信息后点击进入</div>
          </div>
      </div>
    </div>

    <div class="page_end_fixed">
      <endBox></endBox>
    </div>
    <div class="shade" v-if="isShadeShow">
      <div class="again_box">
        <div class="box_title">申请重考
          <img src="https://resources.sxsaas.com/static/jigou-saas-app/close2.png" alt=""
            @click.stop.prevent="closeShade">
        </div>
        <div class="select_box">
          <el-radio-group v-model="radio" @input="radioChange">
            <el-radio class="acitonButton" size="medium" label="1">继续</el-radio>
            <el-radio class="acitonButton" size="medium" label="2">重考</el-radio>
          </el-radio-group>
        </div>
        <div class="reason_box">
          <div class="title">原因</div>
          <el-input class="reason_text" type="textarea" :rows="2" placeholder="请输入内容" v-model="againExam.text" rows="6"
            resize='none'>
          </el-input>
        </div>
        <div class="send_btn" @click.stop.prevent="sendAgain">
          确认
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _getExamInfo, _getExamQues, _enterExam } from "../../api/TYKSStart"
export default {
  components: {},
  created() {
    window.localStorage.removeItem("exam_ques")
    this.getExamInfo()
    this.checkTime();
    this.getExamQues()
  },

  mounted() { },
  data() {
    return {
      examID: null,
      className: window.localStorage.getItem("className") || "",
      isShadeShow: false,
      radio: '1',
      btnIsCanClick: false,
      overTimeText: "",
      timeer: null,
      pageData: {
        "error_status": "",
        "error_msg": "",
        "recordNum": "",
        "grant_info": {
          "id": "",
          "title": "",
          "start_time": {
            "val": "",
            "format": ""
          },
          "end_time": "",
          "allow_num": "",
          "allow_late": "",
          "is_finish": "",
          "stu_type": {
            "val": "",
            "format": ""
          },
          "pro_id": "",
          "exam_duration": "",
          "qualified_score": ""
        },
        "stu_info": {
          "id": "",
          "stu_name": "",
          "stu_tel": {
            "val": "",
            "format": ""
          },
          "stu_code": {
            "val": "",
            "format": ""
          },
          "stu_sex": {
            "val": "",
            "name": ""
          },
          "work_unit": ""
        }
      },
      diffDate: {
        day: "",
        hours: "",
        minutes: "",
        seconds: "",
      },
      againExam: {
        type: 1,
        text: ""
      }
    };
  },
  methods: {
    backPage() {
      const examType = this.$route.query.examType;
      if (examType) {
        this.$router.push({ name: 'TYKSList', query: { examType } });
      } else {
        this.$router.push({ name: 'TYKSList' });
      }
    },
    async getExamInfo() {
      let params = {
        grant_id: window.localStorage.getItem("grantID"),
        isShowErr: true,
      }
      let res = await _getExamInfo(params)

      this.pageData = res.data
      console.log(res.data);

    },
    checkTime() {
      let that = this;
      this.timeer = setInterval(() => {
        //
        // 获取当前时间戳
        const nowTime = new Date().getTime();
        // const nowTime = 1715467521000;
        // 拿考试开始的时间戳 减去当前时间戳
        const gapTime = parseInt(this.pageData.grant_info.start_time.val) - parseInt(nowTime / 1000);
        // 拿考试禁止进入的时间戳 减去当前时间戳
        const diffTime = parseInt(this.pageData.grant_info.end_time.val) - parseInt(nowTime / 1000);

        // 时间到了显示文本 关闭定时器 按钮状态置为可用
        if (gapTime <=0   && diffTime >= 0) {
          that.overTimeText = "考试可以开始";
          that.btnIsCanClick = true;
        } else {
          // 时间未到 就拿时间戳转化成 年月日 时分秒
          if (gapTime > 0 &&diffTime > 0) {
            that.getTime_s(gapTime);
            return
          }
          // 如果已经禁止进入  则提示禁止进入
          if (diffTime < 0) {
            that.btnIsCanClick = false;
            that.overTimeText = "考试已禁止进入";
            clearInterval(that.timeer);
            return
          }
        }
      }, 1000);
    },
    async getExamQues() {
      let params = {
        grant_id: window.localStorage.getItem("grantID"),
        isShowErr: true,
      }
      let res = await _getExamQues(params)

      if (res.data) {
        this.examID = res.data.exam_id
        window.localStorage.setItem("exam_id", res.data.exam_id)

        let temp = JSON.stringify(res.data)
        window.localStorage.setItem("exam_ques", temp)
      }
    },
    // 时间戳转换格式
    getTime_s(timestamp) {
      timestamp = timestamp;

      let day = parseInt(timestamp / (60 * 60 * 24));
      let hours = parseInt((timestamp % (60 * 60 * 24)) / (60 * 60));
      let minutes = parseInt((timestamp % (60 * 60)) / 60);
      let seconds = parseInt(timestamp % 60);

      this.diffDate.day = day;
      this.diffDate.hours = hours < 10 ? "0" + hours : hours;
      this.diffDate.minutes = minutes < 10 ? "0" + minutes : minutes;
      this.diffDate.seconds = seconds < 10 ? "0" + seconds : seconds;

      this.overTimeText = "离考试开始还有"
      if (day != 0) {
        this.overTimeText += this.diffDate.day + "天"
      }
      if (hours != 0) {
        this.overTimeText += this.diffDate.hours + "小时"
      }
      this.overTimeText = this.overTimeText + this.diffDate.minutes + "分钟" + this.diffDate.seconds + "秒"
    },
    examAgin() {
      if (this.btnIsCanClick == true) {
        this.isShadeShow = true
      }
    },
    closeShade() {
      this.isShadeShow = false
    },
    sendAgain() {
      console.log("申请重考");
    },
    async jumpExam() {
      // 果如按钮可用
      if (this.btnIsCanClick == true) {
        if(this.timeer){
          clearInterval(this.timeer);
        }
        let params = {
          grant_id: window.localStorage.getItem("grantID"),
          isShowErr: true,
          exam_id: this.examID
        }
        let res = await _enterExam(params)
        window.localStorage.setItem("grantInfo", JSON.stringify(res.data))
        if (window.localStorage.getItem("exam_ques")) {
          window.sessionStorage.setItem("isCanJumpExam", "true")
          this.$router.replace({ name: "TYKSPage" });
        } else {
          this.$message({ showClose: true, message: "试题未发放或未成功加载，请联系管理员", type: "error" });
        }
      }
    },
    radioChange(e) {
      this.againExam.type = parseInt(e)
      console.log(e);
    }
  },
};
</script>
<style scoped>
/* ========== 顶部导航 ========== */
.back_box {
  width: 100%;
  max-width: 1160px;
  height: 56px;
  background: #fff;
  margin: 12px auto 12px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 24px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.back_left {
  display: flex;
  align-items: center;
  gap: 18px;
}

.back_btn {
  height: 34px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: #f0f2ff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #646eff;
  font-weight: 500;
  transition: all 0.2s;
}

.back_btn:hover {
  background: #e4e7ff;
}

.back_btn i {
  font-size: 13px;
}

.page_title {
  color: #1a1a2e;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.class_name {
  color: #646eff;
  font-weight: 600;
}

.title_sep {
  color: #dcdfe6;
  font-weight: 400;
}

.page_wrapper {
  width: 1160px;
  margin: 0 auto;
  padding-top: 0;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.start_box {
  width: 100%;
  background: linear-gradient(145deg, #f2f4fc 0%, #f7f8fd 100%);
  border-radius: 16px;
  box-sizing: border-box;
  padding: 14px 20px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  box-shadow:
    0 4px 24px rgba(100, 110, 255, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(100, 110, 255, 0.06);
  animation: fadeUp 0.5s ease-out;
  position: relative;
}

.start_box::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 28px;
  right: 28px;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(100, 110, 255, 0.06), rgba(54, 194, 117, 0.04), rgba(245, 166, 35, 0.06), transparent);
  border-radius: 1px;
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 左侧 */
.left {
  width: 460px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.left .section_card:nth-child(1) {
  animation: cardIn 0.45s ease-out 0.1s both;
}

.left .section_card:nth-child(2) {
  animation: cardIn 0.45s ease-out 0.25s both;
}

/* 左右分栏装饰线 */
.divider_line {
  width: 1px;
  align-self: stretch;
  margin: 10px 0;
  background: linear-gradient(180deg, transparent 0%, rgba(100, 110, 255, 0.1) 30%, rgba(100, 110, 255, 0.1) 70%, transparent 100%);
  flex-shrink: 0;
}

/* 右侧 */
.right {
  flex: 1;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.right .section_card {
  animation: cardIn 0.45s ease-out 0.2s both;
}

.right .btn_area {
  animation: cardIn 0.45s ease-out 0.35s both;
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 通用卡片 */
.section_card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04);
  overflow: hidden;
  transition: box-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
}

.section_card:hover {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: rgba(100, 110, 255, 0.08);
}

/* 卡片顶部色带 */
.section_card::before {
  content: '';
  display: block;
  height: 4px;
  background: linear-gradient(90deg, #646eff, #8b8eff);
}

.left .section_card:nth-child(2)::before {
  background: linear-gradient(90deg, #36c275, #5dd89a);
}

.right .section_card::before {
  background: linear-gradient(90deg, #f5a623, #f7c948);
}

/* 区块标题 */
.section_title {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 600;
  color: rgba(29, 37, 54, 1);
  border-bottom: 1px solid #f0f2f5;
  background:
    linear-gradient(90deg, rgba(100, 110, 255, 0.02), transparent 60%),
    #fafbfd;
  border-left: 3px solid #646eff;
}

.left .section_card:nth-child(2) .section_title {
  border-left-color: #36c275;
}

.right .section_card .section_title {
  border-left-color: #f5a623;
}

.center_title {
  justify-content: center;
  border-left: none;
  border-bottom: 1px solid #f0f2f5;
  position: relative;
}

.center_title::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, #f5a623, #f7c948);
  border-radius: 1px;
}

.title_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  margin-right: 10px;
  flex-shrink: 0;
  position: relative;
}

.exam_icon {
  background: linear-gradient(135deg, #646eff, #8b8eff);
}

.exam_icon::after {
  content: '';
  width: 10px;
  height: 8px;
  border: 2px solid rgba(255,255,255,0.85);
  border-radius: 1px;
  margin-top: -1px;
}

.user_icon {
  background: linear-gradient(135deg, #36c275, #5dd89a);
}

.user_icon::after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.85);
  margin-top: -2px;
}

.notice_icon {
  background: linear-gradient(135deg, #f5a623, #f7c948);
}

.notice_icon::after {
  content: '!';
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
}

/* 信息列表 */
.info_list {
  padding: 4px 20px 10px;
}

.info_item {
  display: flex;
  align-items: baseline;
  padding: 6px 10px;
  border-radius: 6px;
  border-bottom: 1px dashed #f0f2f5;
  transition: all 0.25s ease;
}

.info_item:hover {
  background-color: #f5f6fc;
  padding-left: 14px;
  border-bottom-color: transparent;
  border-left: 2px solid rgba(100, 110, 255, 0.15);
}

.info_item:hover .info_label {
  color: #6e7a8a;
}

.info_item:last-child {
  border-bottom: none;
}

/* 考生姓名行特殊样式 */
.name_row {
  background: linear-gradient(90deg, rgba(54, 194, 117, 0.03), transparent);
  border-radius: 8px;
  padding: 12px 10px !important;
  margin-bottom: 4px;
}

.name_row:hover {
  background: linear-gradient(90deg, rgba(54, 194, 117, 0.06), rgba(54, 194, 117, 0.02));
  border-left-color: rgba(54, 194, 117, 0.2);
}

.name_row .info_value {
  font-weight: 600;
  font-size: 15px;
  color: #1d2536;
}

/* 等宽数值样式（身份证、手机号） */
.mono_value {
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  letter-spacing: 0.5px;
  font-size: 13.5px;
  color: #3a3e4a !important;
}

.info_label {
  width: 110px;
  flex-shrink: 0;
  font-size: 13px;
  color: #9099a4;
  line-height: 1.6;
  padding-top: 1px;
  transition: color 0.25s ease;
}

.info_value {
  flex: 1;
  font-size: 14px;
  color: rgba(29, 37, 54, 1);
  word-break: break-all;
  line-height: 1.6;
}

/* 考试名称行特殊样式 */
.title_row {
  background: linear-gradient(90deg, rgba(100, 110, 255, 0.03), transparent);
  border-radius: 8px;
  padding: 12px 10px !important;
  margin-bottom: 4px;
}

.title_row:hover {
  background: linear-gradient(90deg, rgba(100, 110, 255, 0.06), rgba(100, 110, 255, 0.02));
}

.info_value.title_value {
  font-weight: 700;
  font-size: 16px;
  color: #1d2536;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
}

.info_value.highlight {
  color: #646eff;
  font-weight: 600;
  background: rgba(100, 110, 255, 0.06);
  padding: 3px 10px;
  border-radius: 4px;
  display: inline-block;
  max-width: fit-content;
  border-left: 3px solid rgba(100, 110, 255, 0.3);
  transition: background 0.25s ease, border-color 0.25s ease;
}

.info_item:hover .info_value.highlight {
  background: rgba(100, 110, 255, 0.1);
  border-left-color: rgba(100, 110, 255, 0.5);
}

/* 考生须知卡片 */
.notice_card {
  flex: 1;
}

.info_box {
  padding: 8px 20px;
  max-height: 380px;
  overflow-y: auto;
  mask-image: linear-gradient(to bottom, black 90%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 90%, transparent 100%);
}

.notice_item {
  display: flex;
  align-items: flex-start;
  padding: 5px 10px;
  border-radius: 6px;
  border-bottom: 1px solid #f5f7fa;
  transition: all 0.25s ease;
}

.notice_item:hover {
  background-color: #fffbf2;
  padding-left: 14px;
  border-bottom-color: transparent;
}

.notice_item:hover .notice_num {
  transform: scale(1.1);
  box-shadow: 0 3px 8px rgba(245, 166, 35, 0.4);
}

.notice_item:hover .notice_text {
  color: #3a3e4a;
}

.notice_item:last-child {
  border-bottom: none;
}

.notice_num {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #f5a623, #f7c948);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  margin-top: 2px;
  box-shadow: 0 2px 6px rgba(245, 166, 35, 0.3);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.notice_text {
  flex: 1;
  font-size: 13px;
  color: #4a4e5a;
  line-height: 1.5;
  transition: color 0.25s ease;
}

/* 重要警告条目样式 */
.notice_warn {
  background: linear-gradient(90deg, rgba(235, 64, 52, 0.04), rgba(235, 64, 52, 0.01));
  border: 1px solid rgba(235, 64, 52, 0.12);
  border-radius: 8px;
  padding: 12px 10px !important;
  margin-top: 4px;
  border-bottom: none !important;
}

.notice_warn:hover {
  background: linear-gradient(90deg, rgba(235, 64, 52, 0.07), rgba(235, 64, 52, 0.02));
  border-color: rgba(235, 64, 52, 0.2);
  padding-left: 14px !important;
}

.warn_num {
  background: linear-gradient(135deg, #eb4034, #f06b62) !important;
  box-shadow: 0 2px 6px rgba(235, 64, 52, 0.35) !important;
  animation: warnPulse 2s ease-in-out infinite;
}

.notice_warn:hover .warn_num {
  transform: scale(1.1);
  box-shadow: 0 3px 10px rgba(235, 64, 52, 0.45) !important;
}

@keyframes warnPulse {
  0%, 100% { box-shadow: 0 2px 6px rgba(235, 64, 52, 0.35); }
  50% { box-shadow: 0 2px 12px rgba(235, 64, 52, 0.5); }
}

.warn_text {
  color: #c0392b !important;
  font-weight: 500;
  font-size: 13.5px !important;
  line-height: 1.8 !important;
}

.warn_text b {
  color: #eb4034;
  font-weight: 700;
  margin-right: 2px;
}

/* 按钮区域 */
.btn_area {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04);
  padding: 16px 24px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  position: relative;
  overflow: hidden;
}

.btn_area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #646eff, #8b8eff);
}

.countdown_box {
  text-align: center;
  padding: 10px 36px;
  background: linear-gradient(135deg, rgba(100, 110, 255, 0.06), rgba(100, 110, 255, 0.12));
  border-radius: 28px;
  border: 1px solid rgba(100, 110, 255, 0.18);
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.4s ease;
  box-shadow: 0 2px 10px rgba(100, 110, 255, 0.08);
}

.countdown_dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #646eff;
  animation: pulse 1.5s ease-in-out infinite;
  flex-shrink: 0;
}

.countdown_ready {
  background: linear-gradient(135deg, rgba(54, 194, 117, 0.08), rgba(93, 216, 154, 0.14));
  border-color: rgba(54, 194, 117, 0.25);
  box-shadow:
    0 2px 12px rgba(54, 194, 117, 0.1),
    0 0 20px rgba(54, 194, 117, 0.05);
  animation: readyGlow 2s ease-in-out infinite;
}

@keyframes readyGlow {
  0%, 100% { box-shadow: 0 2px 12px rgba(54, 194, 117, 0.1), 0 0 20px rgba(54, 194, 117, 0.05); }
  50% { box-shadow: 0 2px 16px rgba(54, 194, 117, 0.18), 0 0 28px rgba(54, 194, 117, 0.08); }
}

.countdown_ready .countdown_dot {
  background: #36c275;
  animation: pulse_green 1.5s ease-in-out infinite;
}

.countdown_ready .countdown_label {
  color: #36c275;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.8); }
}

@keyframes pulse_green {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(1.2); }
}

.countdown_label {
  font-size: 15px;
  color: rgba(100, 110, 255, 1);
  font-weight: 600;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.countdown_label::first-line {
  font-variant-numeric: tabular-nums;
}

.countdown_icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  position: relative;
  display: inline-block;
}

.countdown_icon::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(100, 110, 255, 0.4);
  border-radius: 50%;
  top: 1px;
  left: 1px;
}

.countdown_icon::after {
  content: '';
  position: absolute;
  width: 2px;
  height: 5px;
  background: rgba(100, 110, 255, 0.6);
  top: 3px;
  left: 7px;
  border-radius: 1px;
  transform-origin: bottom center;
  animation: clockTick 2s ease-in-out infinite;
}

.icon_ready::before {
  border-color: rgba(54, 194, 117, 0.5);
}

.icon_ready::after {
  background: transparent;
  animation: none;
  width: 12px;
  height: 8px;
  border-left: 2.5px solid rgba(54, 194, 117, 0.9);
  border-bottom: 2.5px solid rgba(54, 194, 117, 0.9);
  background: transparent;
  transform: rotate(-45deg);
  top: 5px;
  left: 9px;
}

@keyframes clockTick {
  0%, 100% { transform: rotate(0deg); }
  50% { transform: rotate(180deg); }
}

.btn_group {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.btn {
  padding: 12px 48px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  letter-spacing: 2px;
}

.btn_primary {
  background: linear-gradient(135deg, #646eff, #7b84ff);
  color: #fff;
  box-shadow: 0 4px 14px rgba(100, 110, 255, 0.35);
  position: relative;
  overflow: hidden;
}

.btn_primary::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent);
  transition: left 0.5s ease;
}

.btn_primary:hover::after {
  left: 100%;
}

.btn_primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(100, 110, 255, 0.45);
  background: linear-gradient(135deg, #5a64f0, #7078f0);
}

.btn_primary:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(100, 110, 255, 0.3);
}

.btn_disable {
  background: #e0e3ea !important;
  color: #a0a4ad !important;
  box-shadow: none !important;
  cursor: not-allowed !important;
  transform: none !important;
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 10px,
    rgba(255,255,255,0.08) 10px,
    rgba(255,255,255,0.08) 20px
  ) !important;
}

.btn_hint {
  font-size: 12px;
  color: #b0b5c4;
  text-align: center;
  margin-top: -4px;
  letter-spacing: 0.5px;
}

/* 遮罩弹窗 */
.shade {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 12;
  backdrop-filter: blur(4px);
}

.again_box {
  width: 480px;
  border-radius: 16px;
  overflow: hidden;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  animation: modalIn 0.3s ease-out;
}

@keyframes modalIn {
  from { opacity: 0; transform: translate(-50%, -48%); }
  to { opacity: 1; transform: translate(-50%, -50%); }
}

.again_box .box_title {
  width: 100%;
  height: 54px;
  text-align: center;
  line-height: 54px;
  background: linear-gradient(135deg, #646eff, #7b84ff);
  color: #fff;
  position: relative;
  font-size: 17px;
  font-weight: 600;
}

.again_box img {
  width: 22px;
  height: 22px;
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.again_box img:hover {
  opacity: 1;
}

.select_box {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 24px 20px 12px;
}

:deep(.el-radio__inner) {
  width: 18px;
  height: 18px;
}

.reason_box {
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  padding: 10px 20px 20px 20px;
}

.reason_box .title {
  color: rgba(114, 123, 142, 1);
  font-size: 15px;
}

.reason_box .reason_text {
  margin-top: 10px;
}

.send_btn {
  width: 120px;
  height: 40px;
  display: flex;
  place-content: center;
  place-items: center;
  flex-shrink: 0;
  border-radius: 10px;
  background: linear-gradient(135deg, #646eff, #7b84ff);
  color: #fff;
  align-self: center;
  margin-bottom: 24px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(100, 110, 255, 0.35);
}

.send_btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(100, 110, 255, 0.45);
}

/* 按钮区域就绪态 */
.btn_area.area_ready {
  border-color: rgba(54, 194, 117, 0.1);
}

.btn_area.area_ready::before {
  background: linear-gradient(90deg, #36c275, #5dd89a);
}

/* 考生须知条目交错入场 */
.notice_item:nth-child(1) { animation: cardIn 0.35s ease-out 0.3s both; }
.notice_item:nth-child(2) { animation: cardIn 0.35s ease-out 0.38s both; }
.notice_item:nth-child(3) { animation: cardIn 0.35s ease-out 0.46s both; }
.notice_item:nth-child(4) { animation: cardIn 0.35s ease-out 0.54s both; }
.notice_item:nth-child(5) { animation: cardIn 0.35s ease-out 0.62s both; }
.notice_item:nth-child(6) { animation: cardIn 0.35s ease-out 0.70s both; }
.notice_item:nth-child(7) { animation: cardIn 0.35s ease-out 0.78s both; }
.notice_item:nth-child(8) { animation: cardIn 0.35s ease-out 0.86s both; }

/* 滚动条美化 */
.info_box::-webkit-scrollbar {
  width: 4px;
}

.info_box::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #c5c9d6, #dcdfe6);
  border-radius: 2px;
}

.info_box::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #b0b5c4, #c5c9d6);
}

.info_box::-webkit-scrollbar-track {
  background: transparent;
}
</style>
